// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const dialogActions = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(12)} ${pxToRem(24)}`,
      backgroundColor: "#fafafa",
      borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    },
  },
};

export default dialogActions;
